import script from "./CodiceFeanorView.vue?vue&type=script&setup=true&lang=js"
export * from "./CodiceFeanorView.vue?vue&type=script&setup=true&lang=js"

import "./CodiceFeanorView.vue?vue&type=style&index=0&id=a8817b0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8817b0a"]])

export default __exports__